/* eslint-disable react-refresh/only-export-components -- context module */
import { createContext, useContext, type ReactNode } from 'react';
import { useSiteCampaigns } from './SiteConfigContext';
import type { Campaign } from '../config/campaigns';

type CampaignsState = {
  campaigns: Campaign[];
  loaded: boolean;
  source: 'json' | 'fallback';
};

const CampaignsContext = createContext<CampaignsState>({
  campaigns: [],
  loaded: false,
  source: 'fallback',
});

/** @deprecated SiteConfigProvider üzerinden kampanyalar yüklenir */
export function CampaignsProvider({ children }: { children: ReactNode }) {
  const { campaigns, loaded } = useSiteCampaigns();
  return (
    <CampaignsContext.Provider
      value={{ campaigns, loaded, source: loaded ? 'json' : 'fallback' }}
    >
      {children}
    </CampaignsContext.Provider>
  );
}

export function useCampaigns(): CampaignsState {
  return useContext(CampaignsContext);
}
